import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {CANCELED_FILE_UPLOAD_STATUS} from 'MyAccount/AssetManager/ImageManager/consts';
import { changeFileStatusError, changeSearchFile, removeAllImagesFromBar } from 'MyAccount/ViewDesigns/redux/modules/images';
import { store } from 'App/store';
import { openLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import { PANELS } from 'crazyEditor/components/ImageManagerDialogs/ImageManagerPanels';
import UploadImageStatusBar from 'shared/components/UploadImageStatusBar';

@connect(
  state => ({
    uploadFiles: state.images.Images.uploadFiles,
  }),
  {changeFileStatusError, changeSearchFile, removeAllImagesFromBar, openLazyPanel}
)
export default class MultiItemStatusBarWrapper extends Component {
  static contextTypes = {
    imageUtils: PropTypes.object.isRequired,
  };

  removeAll = () => {
    const {resourceType} = this.props;
    this.props.removeAllImagesFromBar({resourceType});
  };

  cancelUploadingFile = (file) => {
    file.cancelUpload();
    this.props.changeFileStatusError({
      currentFolder: file.folder,
      name: file.name,
      status: CANCELED_FILE_UPLOAD_STATUS,
    });
  };

  retryUploadFile = (file) => {
    if (file.formData) {
      this.context.imageUtils.doUploadFiles({
        path: file.folder,
        file,
      }, (data) => {
        const response = data && data.responseJSON;
        if (response && response.error && response.error.message) {
          // todo show error
          this.setState({ error: response.error.message });
        }
      });
    } else {
      this.context.imageUtils.doUploadFilesFromUrl({
        newUrl: file.url,
        path: file.folder,
        name: file.name,
        retry: true,
      }, (data) => {
        const response = data && data.responseJSON;
        if (response && response.error && response.error.message) {
          // todo show error
          this.setState({ error: response.error.message });
        }
      });
    }
  };

  locateImage = (file) => {
    this.props.changeSearchFile({ searchFile: `${file.folder}${file.name}`});
  };

  openIntegratedErrorImageDialog = (file) => {
    const {openLazyPanel} = this.props;
    openLazyPanel(PANELS.ERROR_IMAGE, null, null, {
      errorMessage: file.error,
      onSubmit: () => this.retryUploadFile(file),
    });
  };

  render() {
    const { uploadFiles, currentFolder, resourceType, integrated } = this.props;
    return (
      <UploadImageStatusBar
        uploadedImages={uploadFiles}
        removeAll={this.removeAll}
        cancelUpload={this.cancelUploadingFile}
        retryUpload={this.retryUploadFile}
        locateImage={this.locateImage}
        currentFolder={currentFolder}
        resourceType={resourceType}
        openCustomErrorImageDialog={integrated ? this.openIntegratedErrorImageDialog : undefined}
      />
    );
  }
}